import React from "react";
import { DeviceCertifiedModeInfoModalTemplate } from "themes/application/device-settings/components";

function DeviceCertifiedModeInfoModal(props) {
    return <DeviceCertifiedModeInfoModalTemplate {...props} />;
}

export default DeviceCertifiedModeInfoModal;
